export const SortTypes = {
    DEFAULT: "Default",
    OFFICE_ID: "OfficeId",
    OFFICE_TYPE: "OfficeType",
    NEW: "NewReturns",
    IN_PROGRESS: "InProgressReturns",
    FILED: "FiledReturns",
    AVG_FILE_TIME_DAYS: "AverageFileTimeDays"
}